<section class="section white-100" *ngIf="readyToData">
  <div class="section-container">
    <div class="section-discover-power">
      <div class="discover-power-content">
        <div class="discover-power-heading">
          {{ readyToData?.title }}
        </div>
        <div class="discover-power-subtext">
          {{ readyToData?.content?.content[0]?.content[0]?.value }}
        </div>
        <div class="landing-btn">
          <app-common-talktosales-button
            [text]="readyToData?.buttons[0]?.fields?.buttonText"
            [hubspotId]="readyToData?.buttons[0]?.fields?.redirectLink"
          ></app-common-talktosales-button>
        </div>
      </div>
      <div class="discover-power-image">
        <img
          loading="lazy"
          [src]="readyToData?.image[0]?.fields?.file?.url"
          alt=""
        />
      </div>
    </div>
  </div>
</section>
